export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "missing-client-id.apps.googleusercontent.com";
export const GEMINI_API_KEY = import.meta.env.VITE_GEMINI_API_KEY;

// Fallback to production API URL if the env var is missing during build
export const API_URL = import.meta.env.VITE_API_URL || (import.meta.env.PROD ? "https://api.opusremote.com.au" : "http://localhost:8080");

if (!import.meta.env.VITE_API_URL) {
  console.warn("VITE_API_URL is not set. Falling back to:", API_URL);
}

export const API_OPEN_METEO = import.meta.env.VITE_OPEN_METEO;
export const API_OPEN_STREET = import.meta.env.VITE_OPEN_STREET;
export const CALENDAR_URL = import.meta.env.VITE_CALENDAR_URL;
export const DEVELOPMENT = import.meta.env.VITE_DEVELOPMENT;
export const GOOGLE_MAP = import.meta.env.VITE_GOOGLE_MAP;
export const IP_API = import.meta.env.VITE_IP_API;
